export default "__VITE_ASSET__CFlhzEv7__"